<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQueryCus">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['factory']">
              <a-select showSearch optionFilterProp="children" v-model="queryParam.factoryId" :options="factoryOptions" :placeholder="language['column.pleaseChoose'] + language['factory']" allowClear>
               </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['legalperson']">
              <a-select showSearch optionFilterProp="children" v-model="queryParam.legalpersonId" :options="legalpersonOptions" :placeholder="language['column.pleaseChoose'] + language['legalperson']" allowClear>
               </a-select>
            </a-form-item>
          </a-col>
          
          <template v-if="toggleSearchStatus">
            
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <!--<a-form-item label="事业群">
                <a-select  placeholder="请选择事业群"  v-model="queryParam.businessGroupId"
                           :options="businessGroupOptions"
                           @change="handleGroupVal" allowClear>
                </a-select >
               </a-form-item>-->
              <a-form-model-item :label="language['businessGroupName']" :labelCol="labelCol"  prop="businessGroupId">
                <a-select  :placeholder="language['column.pleaseChoose'] + language['businessGroupName']"  v-model="queryParam.businessGroupId" @change="backDepartGroup" :backDepart="true" :treeOpera="true">
                  <a-icon slot="suffixIcon" type="gold" />
                  <a-select-option
                    v-for="d in groupDepartOptions"
                    :key="d.id"
                    :value="d.id">
                    {{ d.departName }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>

            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
             <!-- <a-form-item label="事业处">
                <a-select
                  placeholder="请选择事业处"
                  v-model="queryParam.businessUnitId"
                  :options="businessUnitOptions"
                  allowClear>
                </a-select>
               </a-form-item>-->
              <a-form-model-item :label="language['businessUnitName']" :labelCol="labelCol" prop="businessUnitId">
                <a-select  :placeholder="language['column.pleaseChoose'] + language['businessUnitName']" v-model="queryParam.businessUnitId" @change="backDepartUnit" :backDepart="true" :treeOpera="true">
                  <a-icon slot="suffixIcon" type="gold" />
                  <a-select-option
                    v-for="d in nextDepartOptions"
                    :key="d.id"
                    :value="d.id">
                    {{ d.departName }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>

            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-model-item :label="language['rectify.inspectUserNames']" :labelCol="labelCol" prop="inspectUserNames">
                <a-select :placeholder="language['common.pleaseInput'] + language['rectify.inspectUserNames']"  @change="inspectUserhange"  :backDepart="true" :treeOpera="true">
                  <a-icon slot="suffixIcon" type="gold" />
                  <a-select-option
                    v-for="d in inspectUserOptions"
                    :key="d.id"
                    :value="d.realname">
                    {{ d.realname }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="language['dangerLevel']">
                <j-dict-select-tag :placeholder="language['column.pleaseChoose'] + language['dangerLevel']" v-model="queryParam.dangerLevel" dictCode="ep_danger_level" allowClear/>
              </a-form-item>
            </a-col>
            
            <a-col :xl="10" :lg="11" :md="12" :sm="24">
              <a-form-item :label="language['inspectTime']">
                <j-date :placeholder="language['common.chooseStartDate']" class="query-group-cust" v-model="queryParam.startTime"></j-date>
                <span class="query-group-split-cust"></span>
                <j-date :placeholder="language['common.chooseEndDate']" class="query-group-cust" v-model="queryParam.endTime"></j-date>
              </a-form-item>
            </a-col>
            
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQueryCus" icon="search">{{language['common.searchButton']}}</a-button>

              <a-button type="primary" @click="searchResetCus" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? language['common.foldButton'] : language['common.unfoldButton'] }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>

        <a-row>
          <a-button type="primary" icon="download" @click="handleExportXls(language['inspect.danger.level.table'])" style="margin-left: 8px">{{language['common.exportButton']}}</a-button>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    
    <!-- 操作按钮区域 -->
    <!-- <div class="table-operator">
      <a-button @click="handlerUpdate('1')" type="primary" :disabled="disabledState">复查维护</a-button>
      <a-button @click="handlerUpdate('2')" type="primary" :disabled="disabledState">申请延期</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div> -->

    <!-- table区域-begin -->
    <a-tabs>
      <a-tab-pane key="1" :tab="language['list.info.title']">
        <div>
          <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
            <i class="anticon anticon-info-circle ant-alert-icon"></i> {{language['common.choosed']}}
            <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{language['common.item']}}
            <a style="margin-left: 24px" @click="onClearSelected">{{language['common.clear']}}</a>
          </div>

          <a-table
            ref="table"
            size="middle"
            bordered
            rowKey="id"
            class="j-table-force-nowrap"
            :scroll="{x:true}"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="false"
            :loading="loading"
            :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
            @change="handleTableChange">
          </a-table>
        </div>
      </a-tab-pane>

      <a-tab-pane key="2" :tab="language['histogram']">
        <div style="overflow-x: scroll;">
          <bar :dataSource="this.barDataSource" width="2200" />
        </div>
      </a-tab-pane>

    </a-tabs>

    <!-- <ep-danger-check-modal ref="modalForm" @ok="modalFormOk"/> -->
  </a-card>
</template>

<script>
  import { getAction, postAction ,downFile} from '@/api/manage'
   import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  // import EpDangerCheckModal from './modules/EpDangerCheckModal'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import '@/assets/less/TableExpand.less'
  import { filterObj } from '@/utils/util';
  import Pie from '@/components/chart/Pie'
  import Bar from '@/components/chart/Bar'

const scale = [{
  dataKey: 'value',
  alias: '个'
}];

const label = {
  textStyle: {
    fill: '#aaaaaa'
  }
}

const title = {
  offset: 80
}

const tickLine = {
  alignWithLabel: false,
  length: 0
}

const labelformat = {
  textStyle: {
    fill: '#aaaaaa'
  },
  formatter: function formatter(text) {
    return text.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
  }
}
const color = ['type', ['#40a9ff', '#1890ff', '#096dd9', '#0050b3']];

 
  export default {
    name: "EpDangerCheckList",
  //  mixins:[JeecgListMixin],
    components: {
      Pie,Bar
    },
    data () {
      return {
        data: [],
        scale,
        label,
        tickLine,
        title,
        labelformat,
        color,
        description: '隐患程度分析表',
        /* 查询条件-请不要在queryParam中声明非字符串值的属性 */
      queryParam: {},
      /* 数据源 */
      dataSource:[],
      // 表格缓存的数据 - 用来点击取消时回显数据
      cacheData: [],
      /* 分页参数 */
      ipagination:{
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条"
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      /* 排序参数 */
      isorter:{
        column: 'createTime',
        order: 'desc',
      },
      /* 筛选参数 */
      filters: {},
      /* table加载状态 */
      loading:false,
      /* table选中keys*/
      selectedRowKeys: [],
      /* table选中records*/
      selectionRows: [],
      /* 查询折叠 */
      toggleSearchStatus:true,

        url: {
          list: "/epm/report/getInspectDangerStateReport",
          exportXlsUrl: "/epm/report/exportXlsInspectDanger",
          queryFactoryList: '/sys/epFactory/list',
          queryLegalpersonList: '/sys/epPerson/list',
         /* queryBusinessGroupList: "/sys/sysDepart/queryBusinessGroupList",
          queryBusinessUnitList: "/sys/sysDepart/queryBusinessUnitList"*/
          queryEmployeeList: '/sys/employee/QueryEmployeelist',
          queryCurUserUnit: '/sys/employee/getCurrUserUnitDept',
          getGroupUnitList:'/epm/epScopeConfig/getGroupUnitByInSpectUnitID',
        },
        dictOptions:{},
        superFieldList:[],
        factoryOptions: [],
        legalpersonOptions:[],
        disabledState:true,
        id:'',

        newDataSource:[],
        pieDataSource:[],
        barDataSource:[],

        inspectUserOptions:[],
        departList:[],
        curUserUnitDeptName:'',
        curUserUnitDeptOrgCode:'',
        groupDepartOptions:[],
        DepartOptions:[],
        nextDepartOptions:[],
        curinspectDepartId:'',
      }
    },
    created() {

      this.initQueryDate();
      this.searchQueryCus(1);
      this.initfactoryList();
      this.initlegalpersonList();
      this.getCurrUserUnitDept();
      this.initemployeeList();

    },

    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      language() {
        return this.$store.getters.language
      },
      columns() {
        if (this.language) {
          return [
            {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
              title:this.language['factory'],
              align:"center",
              // sorter: true,
              dataIndex: 'factoryName',

            },
            {
              title:this.language['danger.inspectDepart'],
              align:"center",
              // sorter: true,
              dataIndex: 'inspectDepartName',
              // scopedSlots: { customRender: 'dangerState' },
            },
            {
              title:this.language['rectify.inspectUserNames'],
              align:"center",
              // sorter: true,
              dataIndex: 'inspectUserNames'
            },

            {
              title:this.language['levelNum1'],
              align:"center",
              dataIndex: 'levelNum1'
            },
            {
              title:this.language['levelNum2'],
              align:"center",
              // sorter: true,
              dataIndex: 'levelNum2'
            },
            {
              title:this.language['levelNum3'],
              align:"center",
              // sorter: true,
              dataIndex: 'levelNum3'
            },
            {
              title:this.language['levelNum4'],
              align:"center",
              // sorter: true,
              dataIndex: 'levelNum4'
            },
            {
              title:this.language['totalSum'],
              align:"center",
              dataIndex: 'levelSum'
            }
          ]
        }
      }
    },
    methods: {
      initQueryDate(){
        this.queryParam = {startTime: this.getOneMonthDate(),endTime: this.getNowDate()}
      },
      getNowDate()
      {
        let month =parseInt(new Date().getMonth())+1;
        return new Date().getFullYear()+"/"+month+"/"+new Date().getDate();
      },
      getOneMonthDate()
      {
        const dates = new Date()
        dates.setMonth(dates.getMonth() - 1)
        let pastMonth = dates.getMonth() + 1
        let pastDay = dates.getDate()
        if (pastMonth >= 1 && pastMonth <= 9) {
          pastMonth = '0' + pastMonth
        }
        if (pastDay >= 0 && pastDay <= 9) {
          pastDay = '0' + pastDay
        }
        const endDate = dates.getFullYear() + '-' + pastMonth + '-' + pastDay
        return endDate
        //return new Date().getFullYear()+"/"+new Date().getMonth()+"/"+new Date().getDate();
      },

      searchQueryCus(arg){
        console.log('1111');
        if(!this.url.list){
        this.$message.error("请设置url.list属性!")
        return
      }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      var params = this.getQueryParams();//查询条件
      this.loading = true;
      postAction(this.url.list, params).then((res) => {
        if (res.success) {
          //update-begin---author:zhangyafei    Date:20201118  for：适配不分页的数据列表------------
          const result = res.result.records || res.result
          this.dataSource = result.map((v, i)=>{
            v.key = i + 1;
            return v;
          }) || res.result;
          // this.cacheData = JSON.parse(JSON.stringify(res.result.records));
          for (var i=0;i< this.dataSource.length;i++) {
            this.dataSource[i].id = i + 1
          }

          if(res.result.total)
          {
            this.ipagination.total = res.result.total;
          }else{
            this.ipagination.total = 0;
          }

          console.log('this.data==>',this.dataSource);
          //判断是否是稽查人或被稽查人
         // this.dealPieDate(this.dataSource)
          this.barDataSource = []
          this.dealBarData(this.dataSource)
        }else{
          this.$message.warning(res.message)
        }
      }).finally(() => {
        this.loading = false
      })
      },

      handleExportXls(fileName){
        if(!fileName || typeof fileName != "string"){
          fileName = "导出文件"
        }
        let param = this.getQueryParams();
        if(this.selectedRowKeys && this.selectedRowKeys.length>0){
          param['selections'] = this.selectedRowKeys.join(",")
        }
        console.log("导出参数",param)
        downFile(this.url.exportXlsUrl,param).then((data)=>{
          if (!data) {
            this.$message.warning("文件下载失败")
            return
          }
          if (typeof window.navigator.msSaveBlob !== 'undefined') {
            window.navigator.msSaveBlob(new Blob([data],{type: 'application/vnd.ms-excel'}), fileName+'.xls')
          }else{
            let url = window.URL.createObjectURL(new Blob([data],{type: 'application/vnd.ms-excel'}))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', fileName+'.xls')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link); //下载完成移除元素
            window.URL.revokeObjectURL(url); //释放掉blob对象
          }
        })
      },

      //饼状图数据
      dealPieDate(data) {
        for (var index in data) {

          let obj = data[index]

          let item1 = {item:this.language['signedState'], count: obj.signedState};
          let item2 = {item:this.language['deferSignState'], count: obj.deferSignState};
          let item3 = {item:this.language['deferConfirmState'], count: obj.deferConfirmState};
          let item4 = {item:this.language['rectifyedState'], count: obj.rectifyedState};
          let item5 = {item:this.language['archivePassState'], count: obj.archivePassState};


          this.pieDataSource.push(item1)
          this.pieDataSource.push(item2)
          this.pieDataSource.push(item3)
          this.pieDataSource.push(item4)
          this.pieDataSource.push(item5)
        }
      },
      //柱状图数据
      dealBarData(data) {
        for (var index in data) {
          let obj = data[index]

          if (obj.inspectUserNames != '合计') {
          //  let name_ = obj.factoryName+','+obj.inspectUserNames;
            let name_ = '\n\n\n\n' + obj.factoryName+',\n'+obj.inspectUserNames
            this.barDataSource.push({name: name_, type:this.language['levelNum1'], value: obj.levelNum1})
            this.barDataSource.push({name: name_, type:this.language['levelNum2'], value: obj.levelNum2})
            this.barDataSource.push({name: name_, type:this.language['levelNum3'], value: obj.levelNum3})
            this.barDataSource.push({name: name_, type:this.language['levelNum4'], value: obj.levelNum4})
          }
        }

        console.log('barDataSource ---------->' ,this.barDataSource)
      },

      getQueryParams() {
      //获取查询条件
      let sqp = {}
      if(this.superQueryParams){
        sqp['superQueryParams']=encodeURI(this.superQueryParams)
        sqp['superQueryMatchType'] = this.superQueryMatchType
      }
      var param = Object.assign(sqp, this.queryParam, this.isorter ,this.filters);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
        //稽查标识
      param.inspectFlag =1;
      return filterObj(param);
     },

     getQueryField() {
      //TODO 字段权限控制
      var str = "id,";
      this.columns.forEach(function (value) {
        str += "," + value.dataIndex;
      });
      return str;
    },

    loadDataSuccess() {
      console.log(this.dataSource)
    },

    searchResetCus() {
      this.queryParam = {}
      this.searchQueryCus(1);
    },

    handleToggleSearch(){
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },

      handleTableChange(pagination, filters, sorter) {
      //分页、排序、筛选变化时触发
      //TODO 筛选
      console.log(pagination)
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
      }
      this.ipagination = pagination;
      this.searchQueryCus();
    },

      onSelectChange(selectedRowKeys, selectionRows) {
        this.selectedRowKeys = selectedRowKeys;
        this.selectionRows = selectionRows;
        this.id = this.selectionRows[0].id;
        this.disabledState = this.selectionRows.length !== 1
      },

      backDepartGroup()
      {
        //清空事业处
        //this.queryParam.businessUnitName = "";
        //this.queryParam.businessUnitId = "";
        this.nextDepartOptions=[];
        //重新填充事业处数据
        this.DepartOptions.forEach(item=>{
          console.log("item.parentId ==========" + item.parentId);
          if(item.levelNo == "40" && item.parentId == this.queryParam.businessGroupId)
          {
            this.nextDepartOptions.push(item);
            console.log(this.nextDepartOptions);
          }
        });
      },

      backDepartUnit(id)
      {
       /* console.log('1111 info ---------->' ,id)
        console.log('2222 info ---------->' ,this.DepartOptions)

        this.DepartOptions.forEach(item=>{
          console.log("item.parentId ==========", item.parentId);
          if(item.levelNo == "40" && item.id == id)
          {
            console.log('3333 info ---------->' ,item)
            this.curUserUnitDeptOrgCode = item.orgCode;
            this.initemployeeList();
          }
        });*/
      },

      //取当前登录人员的事业处
      getCurrUserUnitDept()
      {
        let para = {applicationCode:'env_audit'}
        getAction(this.url.queryCurUserUnit,para).then(res=>{
          if(res){
            this.curUserUnitDeptName = res.departName;
            this.curUserUnitDeptOrgCode = res.orgCode;
            this.curinspectDepartId = res.id;
            console.log(' getCurrUserUnitDept curinspectDepartId===========' + this.curinspectDepartId);
            this.getGroupUnitList();
            this.initemployeeList();
          }
        })
      },
      //取得被稽查的事业群事业处
      getGroupUnitList()
      {
        console.log('getGroupUnitList curinspectDepartId===========' + this.curinspectDepartId);

        let para = {inSpectUnitId:this.curinspectDepartId}
        getAction(this.url.getGroupUnitList,para).then(res=>{
          if(res.success)
          {
            this.DepartOptions = res.result;
            res.result.forEach(item=>{
              if(item.levelNo == "15")
              {
                this.groupDepartOptions.push(item)
              }
            });
          }
          console.log('this.DepartOptions==============' + this.DepartOptions);
        })

      },

      inspectUserhange(val)
      {
        console.log("inspect:" , val);
        this.queryParam.inspectName = val
        //this.model.inspectUserNames = val.label;
      },

      //初始化厂区字典
      initfactoryList(){
		  let para={pageNo:1,pageSize:1000};
        getAction(this.url.queryFactoryList,para).then(res=>{
          if(res.success){
            this.factoryOptions = res.result.records.map((item,index,arr)=>{
              let c = {label:item.factoryName, value: item.id+""}
              return c;
            })
            console.log('this.factoryOptions: ',this.factoryOptions)
          }
        })
      },

      //初始化法人字典
      initlegalpersonList(){
		  let para = {pageNo:1,pageSize:10000};
        getAction(this.url.queryLegalpersonList,para).then(res=>{
          if(res.success){
            this.legalpersonOptions = res.result.records.map((item,index,arr)=>{
              let c = {label:item.legalpersonName, value: item.id+""}
              return c;
            })
            console.log('this.legalpersonOptions: ',this.legalpersonOptions)
          }
        })
      },

      //初始化人员典
      initemployeeList(){
        //稽查人，需改为选择稽查部门下的员工
        let unitOrgCode = {unitOrgCode:this.curUserUnitDeptOrgCode};
        console.log('=========unitOrgCode=====' + unitOrgCode);
        getAction(this.url.queryEmployeeList,unitOrgCode).then(res=>{
          if(res.success){
            /*this.inspectUserOptions = res.result.map((item,index,arr)=>{
              let c = {label:item.realname, value: item.id+""}
              return c;
            });*/

            this.inspectUserOptions = []
            res.result.forEach(item=>{
              this.inspectUserOptions.push(item)
            });

            console.log("inspectUserOptions ------>",this.inspectUserOptions)
          }
        });
      },
      backDepartInfo(info) {
        this.model.departIds = this.model.selecteddeparts;
        this.nextDepartOptions = info.map((item,index,arr)=>{
          let c = {label:item.text, value: item.value+""}
          return c;
        })
      },

      initDictConfig(){
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
  /deep/ .g2-tooltip{
      width: 200px !important;
    }
  
</style>